import HomePage from './dashboard-page';

export default HomePage;
